(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nl-aviso"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__nlAvisoVariante) return;
    window.__nlAvisoVariante = true;
    function actualizar() {
      var sel = document.querySelector('variant-picker input[type="radio"]:checked');
      var titulo = sel ? sel.value : '';
      document.querySelectorAll('[data-nl-ocultar]').forEach(function (el) {
        var k = el.getAttribute('data-nl-ocultar');
        el.hidden = !!k && titulo.indexOf(k) > -1;
      });
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('variant-picker input[type="radio"]')) actualizar();
    });
    document.addEventListener('variant:update', function () { setTimeout(actualizar, 50); });
    if (document.readyState !== 'loading') actualizar(); else document.addEventListener('DOMContentLoaded', actualizar);
  })();
  } catch(e) { console.error(e); }
})();

})();
